module.exports = "/_next/static/images/e1d12e7ee6cab33e259ba9f885471333-anticipate-lg.png";